<script setup lang="ts">
defineOptions({
  inheritAttrs: false,
})

const props = defineProps<{
  label: string
  hideLabel?: boolean
  small?: boolean
  disabled?: boolean
}>()
const inputId = useId()
const modelValue = defineModel()

const labelClasses = computed(() => ({
}))

const inputClasses = computed(() => ({
  'size-4': !props.small,
  'size-3': props.small,
  'cursor-not-allowed': props.disabled,
}))
</script>

<template>
  <label
    class="flex gap-x-2 gap-y-1 whitespace-nowrap items-center relative"
    :class="labelClasses"
  >
    <input
      :id="inputId"
      v-model="modelValue"
      v-bind="$attrs"
      :disabled
      type="checkbox"
      class="ics-q21lws"
      :class=" inputClasses"
    >
    <slot>
      <span :class="{ 'sr-only': hideLabel, 'text-sm': small }">{{ label }}</span>
    </slot>

  </label>
</template>
